import {Form} from "formik";
import React from "react";
import generatePropsFromAttributes from "../parser/utils/generatePropsFromAttributes";

export const form = (node, index, children) => {
  const props = generatePropsFromAttributes(node.attribs, index);
  return <Form {...props}>{children}</Form>;
};
